<template>

</template>

<script>
export default {
  name: "MakeCollection.vue"
}
</script>

<style scoped>

</style>